import axios from 'axios'
var Ownership = {};
var _baseURL = process.env.VUE_APP_AUTH_API + '/ownerships'
Ownership.install = function(Vue) {
  Vue.prototype.$ownership = {
    fetch(params, callback, errorCallback) {
      axios({
        method: 'GET',
        url: _baseURL,
        params,
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
    update(ownership, callback, errorCallback) {
      axios({
        method: 'PATCH',
        url: `${_baseURL}/${ownership.id}`,
        data: { ownership },
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
    fetchAvailableOrgs(type, callback, errorCallback) {
      axios({
        method: 'GET',
        url: `${_baseURL}/available_orgs`,
        params: { type },
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
    create(ownership, callback, errorCallback) {
      axios({
        method: 'POST',
        url: `${_baseURL}`,
        data: { ownership, type: ownership.type },
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
    destroy(ownership, callback, errorCallback) {
      axios({
        method: 'DELETE',
        url: `${_baseURL}/${ownership.id}`,
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
  }
}

export default Ownership;
